import React from 'react';
import { get } from 'lodash';
import { FieldArray, useFormikContext } from 'formik';
import { NavLink } from 'react-router-dom';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import ListTable from '~/commons/components/ListTable.jsx';
import ListResource from '../lists/ListResource.jsx';
import FieldArrayCards from './FieldArrayCards.jsx';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

const FieldsPlayersList = ({
  className
}) => {
  // const api = '/api/site/players';
  const ctx = useFormikContext();
  const arr = get(ctx.values, 'players', []);
  return (
    <ListTable
      {...{
        className,
        cols: [
          { key: 'owner', sortable: false, children: 'Owner', getter(v) {
            return (
              <NavLink className="nav-link" to={`/admin/players/${v._id}`}>{v ? v.name : ''}</NavLink>
            )
          }},
          { key: 'horse', sortable: false, children: 'Horse', getter(v) {
            return (
              <NavLink className="nav-link" to={`/admin/horses/${v._id}`}>{v ? v.name : ''}</NavLink>
            )
          }},
          { key: 'result', sortable: false, children: 'Result' },
          { key: 'place', sortable: false, children: 'Place' },
          // { key: 'horsePics.src', sortable: true, children: 'Pics' },
        ],
        rows: arr,
        // onRowClick,
        // selected: onSelect ? selected : null,
        // onSelect: onSelect ? (s) => {
        //   setSelected(s);
        //   onSelect(s.map((i) => (
        //     fetched.rows[i]
        //   )));
        // } : undefined,
        // sort: query.sort,
        // onSort: (s) => fetch({ sort: s }),
      }}
    />
    /*
    <>
      <FieldArray name="players">
        {(helper) => (
          <>
            <div className="row">
              <FieldArrayIterables name="players">
                {(s, i, helpers) => (
                  <div className="col-auto justify-content-center align-items-center" key={i}>
                    <div className="text-center">
                      <img src={s.image} width={100}/>
                    </div>
                    <div className="text-center">
                      {s.name}
                    </div>
                  </div>
                )}
              </FieldArrayIterables>
            </div>
          </>
        )}
      </FieldArray>
    </>
    */
  );
};

export default FieldsPlayersList;
